module.exports = __webpack_public_path__ + "img/e01ec0b.jpg";